const initialState = {
  practice_id: 1,
  account_id: 1,
  userProfile: null,
};
export default initialState;
